import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import { UserRegisteration, userSignIn } from "app/models/Auth.model";
import { environment } from "../../environments/environment";
import { ItemPagination } from "app/modules/admin/apps/file-manager/file-manager.types";
@Injectable({
  providedIn: "root",
})
export class LabelService extends DMSBaseService {
  constructor(public provider: ServiceProvider) {
    super("/labels", provider);
  }

  public getLabels(){
    return  this.getList('/all')
  }
  
  public addLabel(data) {
    return this.save(data);
  }

  public updateLabel(data) {
    return this.update(data,"")
  }

  public saveLabel(data) {
    if (data.id != null) return this.updateLabel(data);
    return this.addLabel(data);

    }

  public assignLabel(labelId , assetId){
      return this.save(null,`/assign-label-to-asset/${labelId}/${assetId}`)
    }

   public updateSequence(labelId:string,newSequence:number){
    return this.update(null,`/change-sort-order/${labelId}/${newSequence}`)
   } 

   removeLabel(labelId, assetId){
    return this.deleteRecord(`delete-assigned-label/${labelId}/${assetId}`)
   }

}
